import { getScreenRect } from "@client/lib/coords";
import { type LeftTop } from "@client/types";
import { type StickSide } from ".";

export const getStickSide = (position: LeftTop): StickSide => {
  const screenRect = getScreenRect();
  return position.left <= screenRect.width / 2 ? "left" : "right";
};
